<div class="container-idle" [class.show]="">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>{{(productId)?'Edición de producto':'Crea un producto'}}</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm">
							<div class="row">
								<div class="col-sm form-group">
									<label for="code" class="form-label">Código <span style="color: lightgray;">(hijo)</span></label>
									<input type="text" [(ngModel)]="newProduct.code" placeholder="Código del producto"
										name="code" id="code" class="form-control">
								</div>
								<div class="col-sm form-group">
									<label for="code" class="form-label">Código de barras</label>
									<input type="text" [(ngModel)]="newProduct.barCode" placeholder="Código de barras"
										name="code" id="code" class="form-control">
								</div>
							</div>
						</div>
						<div class="col-sm form-group">
							<label for="name" class="form-label">Nombre <span class="required">*</span></label>
							<input type="text" [(ngModel)]="newProduct.name" placeholder="Nombre del producto"
								name="name" id="name" class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col-sm form-group">
							<label for="description" class="form-label">Descripción </label>
							<input type="text" [(ngModel)]="newProduct.description"
								placeholder="Descripción del producto" name="description" id="description"
								class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col-sm">
							<div class="row">
								<div class="col-sm form-group" *ngIf="catalogs">
									<label for="family" class="form-label">Familia <span
											class="required">*</span></label>
									<select name="family" id="family" class="form-select"
										[(ngModel)]="newProduct.parentCategory">
										<option *ngFor="let family of catalogs?.productCategories"
											value="{{family.id}}">{{family.name}}</option>
									</select>
								</div>
								<div class="col-sm form-group"
									*ngIf="newProduct?.parentCategory && categories[newProduct.parentCategory]?.length > 0">
									<label for="subfamily" class="form-label">Subfamilia</label>
									<select name="subfamily" id="subfamily" class="form-select"
										[(ngModel)]="newProduct.category">
										<option *ngFor="let subfamily of categories[newProduct.parentCategory]"
											value="{{subfamily.id}}">{{subfamily.name}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm form-group" *ngIf="newProduct.notAssociated">
							<label class="form-label">Producto Asociado <span style="color: lightgray;">(padre)</span>
								<span class="required">*</span>
							</label>
							<div class="input-group input-group-sm">
								<button class="btn btn-info" *ngIf="newProduct.idAssociated">
									<i class="fa-solid fa-broom clickeable" tooltip="Limpiar" (click)="clean()"></i>
								</button>
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.product"
									[placeholder]="'Ingresa un producto'" [filterElements]="filter"
									[typeElements]="'product-search'" (inputMethod)="writeProduct($event.event)"
									(changeStatus)="check($event.filterElement)"
									(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - ' + $event.filterElement.name"></app-input-autocomplete>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm">
							<div class="row">
								<div class="col-sm form-group" *ngIf="catalogs">
									<label for="measurement" class="form-label">Tipo de medida <span
											class="required">*</span></label>
									<select name="measurement" id="measurement" class="form-select"
										[(ngModel)]="newProduct.measurement">
										<option *ngFor="let measurement of catalogs?.measurementCategories"
											value="{{measurement.id}}">{{measurement.name}}</option>
									</select>
								</div>
								<div class="col-sm form-group"
									*ngIf="newProduct?.measurement && measurements[newProduct.measurement]?.length > 0">
									<label for="measurementCategory" class="form-label">Unidad de medida <span
											class="required">*</span></label>
									<select name="measurementCategory" id="measurementCategory" class="form-select"
										[(ngModel)]="newProduct.measurementCategory">
										<option *ngFor="let measurementCategory of measurements[newProduct.measurement]"
											value="{{measurementCategory.id}}">{{measurementCategory.unit}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm">
							<div class="row">
								<div class="col-sm form-group">
									<label for="type" class="form-label">Tipo <span class="required">*</span></label>
									<select name="type" id="type" class="form-select" [(ngModel)]="newProduct.type">
										<option value="b">Bien</option>
										<option value="s">Servicio</option>
									</select>
								</div>
								<div class="col-sm form-group" *ngIf="newProduct?.type == 'b'">
									<label for="productType" class="form-label">Tipo de Bien <span
											class="required">*</span></label>
									<select name="productType" id="productType" class="form-select"
										[(ngModel)]="newProduct.productType">
										<option value="t">Producto Terminado</option>
										<option value="p">Producto En Proceso</option>
										<option value="m">Materia Prima</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm">
							<div class="row">
								<div class="col-sm form-group" *ngIf="catalogs">
									<label for="measurement" class="form-label">Impuesto Extra</label>
									<select
										name="measurement"
										id="measurement"
										class="form-select"
										[(ngModel)]="newProduct.extraTaxTypeId"
										(ngModelChange)="onExtraTaxTypeChange($event)"
										>
										<option [ngValue]="null">No tiene Impuesto Extra</option>
										<option *ngFor="let extraTax of catalogs?.extraTypeTaxes" [ngValue]="extraTax.id + ''">
											{{ extraTax.taxTypeName }}
										</option>
									</select>
								</div>
								<div class="col-sm form-group"
									*ngIf="newProduct.extraTaxTypeId && extraTaxes[newProduct?.extraTaxTypeId]?.length > 0">
									<label for="extraTaxId" class="form-label">Tipo de Impuesto Extra</label>
									<select name="extraTaxId" id="extraTaxId" class="form-select"
										[(ngModel)]="newProduct.extraTaxId">
										<option *ngFor="let extraTax of extraTaxes[newProduct.extraTaxTypeId]"
											value="{{extraTax.id}}">{{extraTax.taxName}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm">
							<div class="form-group">
								<label for="" class="form-label">Puede ser</label>
								<div class="can-be">
									<span [class.opacity-30]="!newProduct.sold" class="text-success"
										(click)="newProduct.sold = !newProduct.sold">
										<i
											[ngClass]="newProduct.sold?'fa fa-circle-check':'fa-regular fa-circle'"></i>Vendido
									</span>
									<span [class.opacity-30]="!newProduct.bought" class="text-success"
										(click)="newProduct.bought = !newProduct.bought">
										<i
											[ngClass]="newProduct.bought?'fa fa-circle-check':'fa-regular fa-circle'"></i>Comprado
									</span>
									<span [class.opacity-30]="!newProduct.notAssociated" class="text-success"
										(click)="newProduct.notAssociated = !newProduct.notAssociated">
										<i
											[ngClass]="newProduct.notAssociated?'fa fa-circle-check':'fa-regular fa-circle'"></i>Asociado
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-8">
							<div class="row">
								<div class="col-sm form-group" *ngIf="catalogs">
									<label for="exempt" class="form-label">Exento de Impuesto</label>
									<select name="exempt" id="exempt" class="form-select" [(ngModel)]="exempt">
										<option value="n">No es Exento de Impuesto</option>
										<option value="d">Exento definitivo de Impuesto</option>
										<option value="p">Puede ser Exento</option>
									</select>
								</div>
								<div class="col-sm form-group" *ngIf="exempt=='d' || exempt =='p'">
									<label for="exemptTextId" class="form-label">Tipo de Exento</label>
									<select name="exemptTextId" id="exemptTextId" class="form-select"
										[(ngModel)]="newProduct.exemptTextId">
										<option *ngFor="let exemptText of catalogs?.exemptTexts"
											value="{{exemptText.id}}">{{exemptText.description}}</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-sm-4" style="display: flex;align-items: center;justify-content: center;">
							<button class="btn btn-primary" (click)="showUploadImage()"><i
									class="fa fa-camera"></i>SUBIR IMAGEN</button>
						</div>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para guardar el producto</p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success" [disabled]="getDisabledSave()" (click)="postProduct()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>{{(productId)?'GUARDAR CAMBIOS':'CREAR'}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="container-idle" *ngIf="loadingImage">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Carga una imagen</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="loadingImage = false;"></i></h1>
				</div>
				<div class="modal-body">
					<div class="input-group">
						<input type="file" class="form-control" (change)="fileChangeEvent($event)" />
					</div>
					<div class="row">
						<div class="col">
							<image-cropper style="max-height: 200px;" output="base64"
								[imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1"
								format="jpg" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)"
								(cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
						</div>
						<div class="col" style="display: flex;width: 100%;justify-content: center;">
							<img [src]="croppedImage" style="max-height: 200px;" />
						</div>
					</div>

				</div>
				<div class="modal-footer">
					<button class="btn btn-info" [disabled]="!croppedImage" (click)="uploadImage()">
						<ng-container *ngIf="!uploadingImage">
							<i class="fa-solid fa-cloud-arrow-up"></i>
						</ng-container>
						<ng-container *ngIf="uploadingImage">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>SUBIR IMAGEN
					</button>
				</div>
			</div>
		</div>
	</div>
</div>